import Config from 'react-native-config';
import base64 from 'react-native-base64';
import { Dispatch } from 'redux';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import {
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherResource
} from 'modules/types/common';
import { getAuthLiteHeaders } from 'services/AuthServices.web';
import DeviceInfoServices from 'services/DeviceInfoServices';
import FileServices from 'services/FileServices';
import { DFDHeaders } from 'serverTypes/authentication';
import { RootDispatch, RootState } from 'store/types';
import { TestResult } from '../types';
import {
  DOWNLOAD_LAB_DETAILS,
  DOWNLOAD_LAB_DETAILS_FAIL,
  DOWNLOAD_LAB_DETAILS_SUCCESS,
  GET_DOCUMENT,
  DOWNLOAD_PATIENT_LETTERS,
  DOWNLOAD_PATIENT_LETTERS_SUCCESS,
  DOWNLOAD_PATIENT_LETTERS_FAIL
} from './actions';
import { labDetailsDownloadDataSelector } from './selectors';

export * from './actions.common';

/**
 * Auth Lite Download Test Results
 */
export const authLiteDownloadLabDetails = (testResult: TestResult) => async (
  dispatch: Dispatch,
  getState: () => RootState
) => {
  const state = getState();
  const { eventId } = testResult;

  // Check for in flight downloads if there are any then return
  if (labDetailsDownloadDataSelector(state)[eventId] === 'pending') {
    return;
  }

  const url = getDispatcherUrl(
    DispatcherCategoryService.HEALTH_RECORDS,
    DispatcherAuthPrefix.AUTHLITE,
    DispatcherResource.LABS,
    `/id/_download`,
    true
  );

  dispatch({ type: DOWNLOAD_LAB_DETAILS, payload: { id: eventId } });

  const auditData = base64.encode(
    JSON.stringify({
      date: testResult?.testDate,
      message: testResult?.name
    })
  );
  const headers = {
    ...getAuthLiteHeaders(state),
    accept: 'application/pdf',
    deviceId: DeviceInfoServices.getDeviceId(),
    [DFDHeaders.mhpAuditData]: auditData
  };

  try {
    const response = await FileServices.download(`lab-details-${Date.now().toString()}.pdf`, url, {
      ...headers
    });

    dispatch({ type: DOWNLOAD_LAB_DETAILS_SUCCESS, payload: { id: eventId, response } });
  } catch (err) {
    dispatch({ type: DOWNLOAD_LAB_DETAILS_FAIL, payload: { id: eventId }, error: err });
  }
};

/**
 * Auth Lite Download Patient letters
 */
export const authLiteDownloadPatientLetter = (documentId: string) => async (
  dispatch: Dispatch,
  getState: () => RootState
) => {
  dispatch({ type: DOWNLOAD_PATIENT_LETTERS, payload: { id: documentId } });

  try {
    let url = `${Config.BINARY_BASE_URL}/al/getDocument/${documentId}?type=pdf`;
    if (Config.BINARY_EXPANSION_BASE_URL) {
      url = getDispatcherUrl(
        DispatcherCategoryService.HEALTH_RECORDS,
        DispatcherAuthPrefix.AUTHLITE,
        DispatcherResource.BINARY,
        `/id/_download`,
        true
      );
    }
    const response = await FileServices.download(
      `patient-letters-${Date.now().toString()}.pdf`,
      url,
      { ...getAuthLiteHeaders(getState(), documentId), accept: 'application/pdf' }
    );

    dispatch({ type: DOWNLOAD_PATIENT_LETTERS_SUCCESS, payload: { id: documentId, response } });
  } catch (err) {
    dispatch({ type: DOWNLOAD_PATIENT_LETTERS_FAIL, payload: { id: documentId }, error: err });
  }
};

export const getAuthLitePatientLetter = (acceptType: string, documentId: string) => (
  dispatch: RootDispatch,
  getState: () => RootState
) => {
  return dispatch({
    type: GET_DOCUMENT,
    payload: {
      client: 'binary',
      request: {
        headers: {
          accept: acceptType,
          ...getAuthLiteHeaders(getState())
        },
        method: 'get',
        url: `al/getDocument/${documentId}`
      }
    }
  });
};
